import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { PushLive } from '@core/models/push-live.model';
import { QuestionSubmissionService } from '@core/services/question-submission/question-submission.service';
import { ActivityNextItem } from '@core/models/common/activity-next-item.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-single-push-live-card',
  templateUrl: './single-push-live-card.component.html',
  styleUrl: './single-push-live-card.component.css',
})
export class SinglePushLiveCardComponent {
  @Input() pushLive?: PushLive;
  @Input() is_myLive: boolean = false;

  nextItem: ActivityNextItem | null = null;
  private subscriptions = new Subscription();

  constructor(
    private readonly questionSubmissionService: QuestionSubmissionService,
    private readonly router: Router
  ) {}

  startLive(pushLiveUuid: string): void {
    const nextItemSub = this.questionSubmissionService.getPushLiveNextItem(pushLiveUuid).subscribe({
      next: (nextItem) => {
        this.nextItem = nextItem;
        if (!this.nextItem) return;

        if (this.nextItem.item_type === 'questionSet') {
          this.router.navigate([`/push/${pushLiveUuid}/test/${this.nextItem.item_uuid}`]);
        } else if (this.nextItem.item_type === 'lesson') {
          this.router.navigate([`/push/${pushLiveUuid}/lesson/${this.nextItem.item_uuid}`]);
        } else if (this.nextItem.item_type === 'certificate') {
          this.router.navigate([`/push-live/${pushLiveUuid}/certificate`]);
        } else if (this.nextItem.item_type === 'certified') {
          if (this.nextItem.item_uuid) {
            window.open(this.nextItem.item_uuid, '_blank');
          }
        }
      },
      error: () => {
        this.nextItem = null;
      },
    });
    this.subscriptions.add(nextItemSub);
  }

  formatDate(date?: string | null): string {
    if (!date) return 'N/A';

    const d = new Date(date);
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  shouldShowButton(): boolean {
    if (!this.pushLive) return false;

    const isCompleted = this.pushLive?.participations?.[0]?.progress === 100;
    const isExpired =
      this.pushLive?.expiration_date &&
      new Date(this.pushLive.expiration_date).getTime() < Date.now();

    if (this.is_myLive && (isCompleted || isExpired)) {
      return false;
    }

    return true;
  }
}
